import { type ChartDataPoint } from 'types/chart';
import { type TooltipContent } from './types';

const formatWeeklySubtitle = (weekData: ChartDataPoint[]): string => {
  if (!weekData?.length) return '';

  const startDate = new Date(weekData[0].date || '');
  const endDate = new Date(weekData[weekData.length - 1].date || '');

  return `${startDate.getDate()}/${startDate.getMonth() + 1} - ${endDate.getDate()}/${endDate.getMonth() + 1}`;
};

const formatMonthlySubtitle = (monthData: ChartDataPoint[]): string =>
  `${monthData?.length || 0} días`;

const formatDailySubtitle = (date: string): string =>
  new Date(date || '').toLocaleDateString('es-ES');

export const getTooltipContent = (data: ChartDataPoint): TooltipContent => {
  const { isWeeklyGroup, weekData, isMonthlyGroup, monthData, label, date } = data;

  if (isWeeklyGroup && weekData) {
    return {
      title: label,
      subtitle: formatWeeklySubtitle(weekData),
      showClickHint: true,
    };
  }

  if (isMonthlyGroup && monthData) {
    return {
      title: label,
      subtitle: formatMonthlySubtitle(monthData),
      showClickHint: false,
    };
  }

  return {
    title: label,
    subtitle: formatDailySubtitle(date || ''),
    showClickHint: false,
  };
};
